import "./IconAlert.scss";

type Props = {
  className?: string;
};

const IconAlert = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className="icon-alert"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.5 9C1.5 4.86 4.8525 1.5 8.9925 1.5C13.14 1.5 16.5 4.86 16.5 9C16.5 13.14 13.14 16.5 8.9925 16.5C4.8525 16.5 1.5 13.14 1.5 9ZM9.75 6C9.75 5.5875 9.4125 5.25 9 5.25C8.5875 5.25 8.25 5.5875 8.25 6V9C8.25 9.4125 8.5875 9.75 9 9.75C9.4125 9.75 9.75 9.4125 9.75 9V6ZM9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C12.315 3 15 5.685 15 9C15 12.315 12.315 15 9 15ZM8.25 11.25V12.75H9.75V11.25H8.25Z"
    />
  </svg>
);

export default IconAlert;
